<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		id?: string;
		class?: string;
		children?: Snippet;
	}

	let { id, class: className, children }: Props = $props();
</script>

<div {id} class={[className, 'mx-auto max-w-[960px] xl:max-w-[1152px] 2xl:max-w-[1440px]']}>
	{@render children?.()}
</div>
